import React from 'react';
import { Users } from 'lucide-react';

const PricingTiers = ({ tiers = [], compact = false }) => (
  <div className="rounded-xl border border-violet-200 bg-violet-50/60 p-4" data-testid="pricing-tiers">
    <div className="flex items-center gap-2 mb-3">
      <Users className="w-4 h-4 text-violet-600" />
      <p className="text-sm font-semibold text-slate-800">Hourly rate by group size</p>
    </div>
    <div className={`grid gap-2 ${compact ? 'grid-cols-2' : 'grid-cols-2 sm:grid-cols-3'}`}>
      {tiers.map((t) => (
        <div
          key={t.students}
          className="rounded-lg bg-white border border-violet-100 px-3 py-2"
          data-testid={`pricing-tier-${t.students}`}
        >
          <p className="text-xs text-slate-500">{t.students === 1 ? '1 student' : `${t.students} students`}</p>
          <p className="text-lg font-bold text-violet-700">₹{t.rate_per_hour}<span className="text-xs font-medium text-slate-500">/hr</span></p>
        </div>
      ))}
    </div>
  </div>
);

export default PricingTiers;
